import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import experienceDetailService from "../service-api/experienceDetailService";
import roleService from "../service-api/roleMaster";

// Initial state
const initialState = {
  data: [],
  activeRoles: [],
  error: null,
  isLoading: true,
  isFormSubmitting: false,
};

export const fetchExperienceDetailByCandidateID = createAsyncThunk(
  "data/fetchExperienceDetailByCandidateID",
  async (id) => {
    const response =
      await experienceDetailService.fetchExperienceDetailByCandidateID(id);
    return response.data;
  }
);

export const updateExperienceDetail = createAsyncThunk(
  "data/updateExperienceDetail",
  async ({ id, formData }) => {
    const response = await experienceDetailService.updateExperienceDetail(
      id,
      formData
    );
    return response.data;
  }
);

export const addExperienceDetail = createAsyncThunk(
  "data/addExperienceDetail",
  async (obj) => {
    const response = await experienceDetailService.addExperienceDetail(obj);
    return response.data;
  }
);

export const deleteExperienceDetail = createAsyncThunk(
  "data/deleteExperienceDetail",
  async (id) => {
    const response = await experienceDetailService.deleteExperienceDetail(id);
    return response.data;
  }
);

// Create slice
const experienceDetailSlice = createSlice({
  name: "role",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchExperienceDetailByCandidateID.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(
        fetchExperienceDetailByCandidateID.fulfilled,
        (state, action) => {
          state.isLoading = false;
          state.data = action.payload.value;
        }
      )
      .addCase(fetchExperienceDetailByCandidateID.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });

    builder
      .addCase(updateExperienceDetail.pending, (state) => {
        state.isFormSubmitting = true;
      })
      .addCase(updateExperienceDetail.fulfilled, (state, action) => {
        state.isFormSubmitting = false;
      })
      .addCase(updateExperienceDetail.rejected, (state, action) => {
        state.isFormSubmitting = false;
        state.error = action.error.message;
      });

    builder
      .addCase(addExperienceDetail.pending, (state) => {
        state.isFormSubmitting = true;
      })
      .addCase(addExperienceDetail.fulfilled, (state, action) => {
        state.isFormSubmitting = false;
      })
      .addCase(addExperienceDetail.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });

    builder
      .addCase(deleteExperienceDetail.pending, (state) => {
        state.isFormSubmitting = true;
      })
      .addCase(deleteExperienceDetail.fulfilled, (state, action) => {
        state.isFormSubmitting = false;
      })
      .addCase(deleteExperienceDetail.rejected, (state, action) => {
        state.isFormSubmitting = false;
        state.error = action.error.message;
      });
  },
});

export default experienceDetailSlice.reducer;
